// extracted by mini-css-extract-plugin
export default {"container":"mobile-my-vehicles-item_container__sP7v9","bottom_value":"mobile-my-vehicles-item_bottom_value__EOuOZ"};